import * as PropTypes from 'prop-types'

export interface RangeProps {
  onChange: (range: { min: number; max: number }) => void
  onFinished: (range: { min: number; max: number }) => void
  min: number
  max: number
  minValue?: number
  maxValue?: number
  items: Array<any>
  disabled?: boolean
  mod?: string
  className?: string
  translate?: (s: string) => string
  [x: string]: any
  children?: any
}

export const RangePropTypes = {
  onChange: PropTypes.func.isRequired,
  onFinished: PropTypes.func.isRequired,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  minValue: PropTypes.number,
  maxValue: PropTypes.number,
  items: PropTypes.array,
  disabled: PropTypes.bool,
  mod: PropTypes.string,
  className: PropTypes.string,
  translate: PropTypes.func
}
